import React from "react";
import Modal from 'react-bootstrap/Modal';
import { Link } from "react-router-dom";
import { Player } from '@lottiefiles/react-lottie-player';
import TreeView from "../../../Admin/Indices/TreeView";
import { getPathList } from './utils';

const CopyLessonModal = ({ props, lessonItemState }) => {
    const { t, lesson, indices, lessons } = props;
    const {
        showCopy,
        showDoneCopy,
        showPlayer,
        src,
        currentItem,
        setCurrentItem,
        AllQuestion,
        setAllQuestion,
        handleChangeSelect,
        handleCopy,
        handleClose,
        copyId
    } = lessonItemState;

    if (!showCopy) return null;

    let IndexId = currentItem ? parseInt(currentItem.id) : 0;

    if (showDoneCopy) {
        const pathList = getPathList(indices, IndexId, 1);
        let type = "";
        if (pathList && pathList.length > 0) {
            type = pathList[0].type;
        }
        if (type === "Lessons") {
            type = "Lesson";
        }
        return (
            <Modal
                key="ModalSuccessCopyLesson"
                size="xl"
                show={showCopy}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                enforceFocus={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <i className="icon fal fa-copy"></i>
                        {t('Success.CopyLesson.Title')} : {lesson.Name}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="w-100">
                        <Player
                            autoplay
                            loop
                            src={src}
                            style={{ width: '50%' }}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="row col-12">
                        <div className="col-6">
                            <Link
                                className="btn btn-info w-100"
                                to={`/ControlPanel/${type ? (type === "Fun" ? "Games" : type) : 'Lesson'}/Edit/${copyId}`}
                                title={t("Pages.Lessons.action.edit")}
                            >
                                <i className="icon fas fa-edit"></i>
                                {t('Pages.Lessons.action.edit')}
                            </Link>
                        </div>
                        <div className="col-6">
                            <button type="button" className="btn btn-danger" onClick={handleClose}>
                                <i className="icon fas fa-times"></i>
                                {t('Close')}
                            </button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        );
    }

    return (
        <Modal
            key="ModalCopyLesson"
            size="xl"
            show={showCopy}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            enforceFocus={false}
        >
            <Modal.Header closeButton={!showPlayer}>
                <Modal.Title>
                    <i className="icon fal fa-copy"></i>
                    {t('Pages.Lessons.tools.copy')} : {lesson.Name}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {!showPlayer ? (
                    <>
                        <TreeView
                            IsAdmin={false}
                            currentId={IndexId}
                            title={t('Pages.Lessons.tools.copy_title')}
                            data={indices}
                            setCurrentItem={setCurrentItem}
                        />

                        <div className="form-group">
                            <label className="text-dark font-size-h5" htmlFor="AllQuestion">
                                <i className="icon far fa-globe"></i>
                                {t(`Pages.Lessons.tools.copy_all_question.title`)}
                            </label>
                            <div className="custom-control custom-checkbox my-3 mr-sm-4 py-2 checkbox-dark">
                                <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    onChange={e => setAllQuestion(e.target.checked)}
                                    defaultChecked={AllQuestion}
                                    name="AllQuestion"
                                    id="AllQuestion"
                                />
                                <label className="custom-control-label" htmlFor="AllQuestion">
                                    {t(`Pages.Lessons.tools.copy_all_question.placeholder`)}
                                </label>
                            </div>
                        </div>

                        {!AllQuestion && (
                            lessons && lessons.current && lessons.current.Questions ? (
                                <div className="w-100 bg-white px-3 py-4">
                                    {lessons.current.Questions.sort((a, b) => a.Sort - b.Sort).map((item, index) => (
                                        <div className="form-group" key={`Question-${item.Id}`}>
                                            <div className="custom-control custom-checkbox my-3 mr-sm-4 py-2 checkbox-info">
                                                <input
                                                    type="checkbox"
                                                    className="custom-control-input"
                                                    onChange={e => handleChangeSelect(e.target.checked, item.Id)}
                                                    name={`Question-${item.Id}`}
                                                    id={`Question-${item.Id}`}
                                                />
                                                <label className="custom-control-label d-flex" htmlFor={`Question-${item.Id}`}>
                                                    <div className="text-danger h3 mb-0 mx-1">{index + 1}- </div>
                                                    <div dangerouslySetInnerHTML={{ __html: item.Name }} />
                                                </label>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="w-100 bg-white">
                                    <Player
                                        autoplay
                                        loop
                                        src={process.env.PUBLIC_URL + "/assets/effect/loading/8852-searching-for-word.json"}
                                        style={{ width: '50%' }}
                                    />
                                </div>
                            )
                        )}
                    </>
                ) : (
                    <div className="w-100 bg-primary">
                        <Player
                            autoplay
                            loop
                            src={src}
                            style={{ width: '50%' }}
                        />
                    </div>
                )}
            </Modal.Body>
            {!showPlayer && (
                <Modal.Footer>
                    <div className="row col-12">
                        <div className="col-6">
                            <button type="button" className="btn btn-success" onClick={() => handleCopy(lesson.Id)}>
                                <i className="icon fas fa-copy"></i>
                                {t('Pages.Lessons.tools.copy')}
                            </button>
                        </div>
                        <div className="col-6">
                            <button type="button" className="btn btn-danger" onClick={handleClose}>
                                <i className="icon fas fa-times"></i>
                                {t('Close')}
                            </button>
                        </div>
                    </div>
                </Modal.Footer>
            )}
        </Modal>
    );
};

export default CopyLessonModal;
